import React from 'react';
import classnames from 'classnames';

/**
 * Use to Icomoon icon.
 */
function Icon({
  className,
  iconName,
}: {
  /** Custom classname apply to icon */
  className?: string;
  /** Icon name - defined in _settings.scss file. */
  iconName: string;
}): JSX.Element {
  return (
    <i className={classnames(className, 'fontIcon', `fontIcon--${iconName}`)} />
  );
}

export default Icon;
